<template>
    <section class="questionwrapper">
      <div class="helper-holder">
        <!--<p>appquestion5</p>-->
        <p>What’s the hexadecimal color</p>
        <input type="color" id="successcolor" name="successcolor" value="#ffffff" v-model="colorInputC">
        <label for="successcolor">Pick a color</label>
        <p>of success?</p>
        </div>
    </section>
</template>

<script>
export default {
  data: function () {
    return {
      // binaryInput: ''
      colorInputC: '#ffffff',
      textColorC: '#000',
      colorObjectC: {
        colorInput: this.colorInputC,
        textColor: this.textColorC
      }
    };
  },
  methods: {
    saveColor: function (colorInput) {
      /* colorInput = this.colorInputC;
      this.$emit('update-answer-three', this.colorInputC);
      return this.colorInputC;    */

      colorInput = this.colorInputC;

      const textColor = this.hexToRGB(colorInput);

      this.colorObjectC = {
        colorInput: colorInput,
        textColor: textColor
      };

      this.$emit('update-answer-three', this.colorObjectC);
      return this.colorInputC;
      // return this.colorObjectC;
    },

    hexToRGB: function (h) { // hex to rgb to hsl
      let r = 0; let g = 0; let b = 0;

      // 3 digits
      if (h.length === 4) {
        r = '0x' + h[1] + h[1];
        g = '0x' + h[2] + h[2];
        b = '0x' + h[3] + h[3];

        // 6 digits
      } else if (h.length === 7) {
        r = '0x' + h[1] + h[2];
        g = '0x' + h[3] + h[4];
        b = '0x' + h[5] + h[6];
      }

      // return 'rgb(' + +r + ',' + +g + ',' + +b + ')';
      // },

      // RGBToHSL: function (r, g, b) {
      // Make r, g, and b fractions of 1
      r /= 255;
      g /= 255;
      b /= 255;

      // Find greatest and smallest channel values
      let cmin = Math.min(r, g, b);
      let cmax = Math.max(r, g, b);
      let delta = cmax - cmin;
      let hue = 0;
      let s = 0;
      let l = 0;

      // Calculate hue
      // No difference
      // eslint-disable-next-line brace-style
      if (delta === 0) { hue = 0 }
      // Red is max
      // eslint-disable-next-line brace-style
      else if (cmax === r) { hue = ((g - b) / delta) % 6 }
      // Green is max
      else if (cmax === g) {
        hue = (b - r) / delta + 2;
      // eslint-disable-next-line brace-style
      }
      // Blue is max
      else { hue = (r - g) / delta + 4 }

      hue = Math.round(hue * 60);

      // Make negative hues positive behind 360°
      if (hue < 0) { hue += 360 }

      // Calculate lightness
      l = (cmax + cmin) / 2;

      // Calculate saturation
      s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

      // Multiply l and s by 100
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      // Ta reda på om lightness är över eller under 50%

      // console.log(l);

      if (l >= 50) {
        this.colorObjectC.textColor = '#000';
        // console.log('luminosity är light');
      } else {
        this.colorObjectC.textColor = '#FFF';
        // console.log('luminosity är dark');
      }

      // return this.textColorC;
      return this.colorObjectC.textColor;
      // return 'hsl(' + hue + ',' + s + '%,' + l + '%)';
    }
  },
  computed: {

  },
  watch: {
    colorInputC: function () {
      this.saveColor();
    }
  }
};
</script>

<style>

</style>
